import PropTypes from 'prop-types'
import React from 'react'
import '../../styles/ClientStyles.scss'
import './css/BasicLayout.scss'

export const BasicLayout = ({ body: Body }) => (
  <div className="text-center viewport-layout">
    <div className="fixed-block z-index">

    </div>
    <div
      className={`container custom-content-container text-center `}
    >
      <div className="page-layout-viewport">
        <Body />
      </div>
    </div>
  </div>
)

BasicLayout.propTypes = {
  body: PropTypes.any
}

export default BasicLayout



// WEBPACK FOOTER //
// ./src/layouts/BasicLayout/BasicLayout.js